import PurchaseAdd from "./components/PurchaseAdd";
export default PurchaseAdd;
